import { Flex } from '@smarterservices/smarter-ui';
import React from 'react';
import SinglePane from '../SinglePane';
import StepInstructions from '../Common/StepInstructions';

const ConnectedToProctor = ({ stepData }) => {
  return (
    <SinglePane>
      <Flex direction="column" alignItems="center" justifyContent="center">
        <StepInstructions instructions={stepData?.body} />
      </Flex>
    </SinglePane>
  );
};

export default ConnectedToProctor;
